import * as React from 'react';
import { graphql } from 'gatsby';
import { Metadata, TeamCard } from '@/components';
import { Team } from '@/types';
import { LanguageBlock } from '@/components/language-block/language-block';
import { useI18next } from 'gatsby-plugin-react-i18next';

const DrSvetoslavaKarpanova = () => {
  const { t } = useI18next();

  return (
    <>
      <div className="first-section container-fluid container-fluid--custom">
        <div className="row">
          <div className="col-12 col-lg-9 p-0">
            <section className="info bg-gray-200 p-4">
              <TeamCard
                member={Team.DR_SVETOSLAVA_KARPAROVA}
                imageOnly={true}
                className="d-lg-block float-lg-start bio-image me-lg-4 mb-5"
              />
              <h1 className="d-none d-lg-block mb-2">{t('dr-svetoslava-karpanova.hero-title')}</h1>
              <h1 className="d-block d-lg-none mb-2 display-2 fw-bold text-center">
                {t('dr-svetoslava-karpanova.hero-title')}
              </h1>

              <p className="d-none d-lg-block mb-5 fs-4">{t('dr-svetoslava-karpanova.hero-subtitle')}</p>
              <p className="d-block d-lg-none mb-5 text-center fs-4">{t('dr-svetoslava-karpanova.hero-subtitle')}</p>

              <p>
                <strong>{t('g.gymnasium')}</strong>: {t('dr-svetoslava-karpanova.left-subheading.1-1')}
              </p>
              <p>
                <strong>{t('g.medical-degree')}</strong>: {t('dr-svetoslava-karpanova.left-subheading.1-2')}
              </p>
              {t('dr-svetoslava-karpanova.left-body.1')
                .split('\n\n')
                .map((line, index) => (
                  <p key={index} className="my-2 mb-3">
                    {line}
                  </p>
                ))}
            </section>
            <section className="p-4">
              <h2 className="mb-5">{t('dr-svetoslava-karpanova.left-heading.1')}</h2>
              <ul className="list-unstyled mb-5">
                {t('dr-svetoslava-karpanova.left-list.1')
                  .split('\n\n')
                  .map((line, index) => (
                    <li key={index} className="my-2 mb-3">
                      {line}
                    </li>
                  ))}
              </ul>
            </section>
            <section className="bg-gray-200 p-4">
              <h2 className="mb-5">{t('dr-svetoslava-karpanova.left-heading.2')}</h2>
              <ul className="list-unstyled mb-5">
                {t('dr-svetoslava-karpanova.left-list.2')
                  .split('\n\n')
                  .map((line, index) => (
                    <li key={index} className="my-2 mb-3">
                      {line}
                    </li>
                  ))}
              </ul>
            </section>
            <section className="p-4">
              <h2 className="mb-5">{t('dr-svetoslava-karpanova.left-heading.3')}</h2>
              <ul className="list-unstyled mb-5">
                {t('dr-svetoslava-karpanova.left-body.3')
                  .split('\n\n')
                  .map((line, index) => (
                    <p key={index} className="my-2 mb-3">
                      {line}
                    </p>
                  ))}
              </ul>
            </section>
          </div>
          <div className="col-12 col-lg-3 bg-default-green text-white p-4">
            <h2 className="mt-5 mb-5">{t('dr-svetoslava-karpanova.right-heading.1')}</h2>
            <LanguageBlock
              language={t('g.english')}
              listening="C1"
              understandingWriting="C1"
              interacting="C1"
              production="C1"
              writing="C1"
            />
            <LanguageBlock
              language={t('g.german')}
              listening="A2"
              understandingWriting="A2"
              interacting="A2"
              production="A2"
              writing="A2"
            />{' '}
            <LanguageBlock
              language={t('g.russian')}
              listening="B2"
              understandingWriting="B2"
              interacting="B2"
              production="B2"
              writing="B2"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export const Head = (props) => {
  const { data, pageContext } = props;
  const locale = JSON.parse(data?.locales?.edges?.[0]?.node?.data || null);

  return (
    <Metadata
      title={`${locale.g.biography} - ${locale?.['dr-svetoslava-karpanova']['hero-title']}`}
      fallbackTitle={locale?.g.title}
      pageContext={pageContext}
      locale={locale}
    />
  );
};

export default DrSvetoslavaKarpanova;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
